import React from 'react';
import classNames from 'classnames';
import TooltipOnHover from '../../../../components/TooltipOnHover';
import { TOOLBAR_COLLAPSE_BUTTON } from './ToolbarCollapse';
import { TOOLBAR_EXPAND_BUTTON } from './ToolbarExpand';
var SKIP_SNAPSHOT = [TOOLBAR_COLLAPSE_BUTTON, TOOLBAR_EXPAND_BUTTON];

function ToolbarSmallButton(_ref) {
  var button = _ref.button,
      editor = _ref.editor,
      isInsertion = _ref.isInsertion,
      dimmed = _ref.dimmed;
  var canApply = button.canApply ? button.canApply(editor) : true;
  var onMouseDown = React.useCallback(function (event) {
    return event.preventDefault();
  }, []);
  var onClick = React.useCallback(function () {
    button.onApply(SKIP_SNAPSHOT.includes(button.id) ? editor : editor.snapshotSelection());
    if (isInsertion) editor.dismissToolbar();
    return false;
  }, [button, editor, isInsertion]);
  if (!canApply) return false;
  var active = button.isActive ? button.isActive(editor) : false;
  return React.createElement(TooltipOnHover, {
    id: button.id,
    placement: "top",
    tooltipContent: React.createElement("div", null, React.createElement("div", {
      className: "font-size-normal"
    }, button.title), button.tooltipSubtitle && React.createElement("div", {
      className: "font-size-small"
    }, button.tooltipSubtitle))
  }, React.createElement("div", {
    "data-toolbar-button": button.id,
    onMouseDown: onMouseDown,
    onClick: onClick,
    className: classNames('padding-small pointer', {
      primary: active,
      'shade-20 shade-10-on-hover': !active && !dimmed,
      'shade-30 shade-20-on-hover': !active && dimmed
    })
  }, React.createElement(button.icon, {
    style: {
      display: 'block',
      pointerEvents: 'none'
    }
  })));
}

export default React.memo(ToolbarSmallButton);